import { useCallback, useEffect, useState } from 'react'
import { HiChevronUpDown, HiChevronDown, HiMiniTrash } from 'react-icons/hi2'

import { Pills } from './Pills'
import { EvaluationsStars } from './EvaluationStars'
import { Select } from './Select'
import { ModalAlert } from './ModalAlert'

import Evaluation360 from '../../API/Evaluation/Evaluation360'
import { translate } from '../../i18n/Library/relationship'
import { FormattedMessage, useIntl } from 'react-intl'
import Loading from '../Loading/Loading'
import { evaluation360 } from '../../i18n/translatedMessages'

const relationOptions = [
	{ id: 'peer', value: 'Pares' },
	{ id: 'team', value: 'Jefe' },
	{ id: 'boss', value: 'Equipo' },
	{ id: 'auto', value: 'Autoevaluacíon' },
]

const statusOptionsEs = [
	{ id: 'active', value: 'Activo' },
	{ id: 'inactive', value: 'Expirado' },
]

const statusOptionsPt = [
	{ id: 'active', value: 'Ativo' },
	{ id: 'inactive', value: 'Expirado' },
]

export function Evaluation() {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'

	const statusOptions = language === 'pt' ? statusOptionsPt : statusOptionsEs

	const [loading, setLoading] = useState(false)

	const [openIndex, setOpenIndex] = useState(null)
	const [open, setOpen] = useState(false)

	const [targets, setTargets] = useState(null)
	const [selectedRespondentId, setSelectedRespondentId] = useState(null)
	const [templateId, setTemplateId] = useState()

	const [searchName, setSearchName] = useState('')
	const [selectedRelation, setSelectedRelation] = useState(null)
	const [selectedStatus, setSelectedStatus] = useState(null)

	const [answers, setAnswers] = useState([])

	const [evaluation, setEvaluation] = useState([])

	const [isEditing, setIsEditing] = useState(false)

	const loadData = useCallback(async () => {
		try {
			const { id } = JSON.parse(localStorage.getItem('user'))
			const response = await Evaluation360.allRelationship(id)
			setTargets(response)
		} catch (error) {
			console.error('Evaluation history - loadData: ', error)
		}
	}, [])

	const loadEvaluations = async targetId => {
		try {
			setLoading(true)
			const response = await Evaluation360.allAnswers(targetId)
			setTemplateId(response.templateId)
			setAnswers(response.answers)
			setEvaluation([...response.answers])
			setLoading(false)
		} catch (error) {
			console.error('Evaluation history - handleOpen: ', error)
		}
	}

	useEffect(() => {
		loadData()
	}, [loadData])

	const handleAccordionClick = (index, targetId) => {
		loadEvaluations(targetId)
		setOpenIndex(prevIndex => (prevIndex === index ? null : index))
	}

	const handleEvaluation = ({ dataset, criteriaId }) => {
		setEvaluation(prevEvaluation => {
			const index = prevEvaluation.findIndex(e => e.criteriaId === criteriaId)
			const updatedResponse = {
				...prevEvaluation[index],
				response: dataset,
			}

			if (index !== -1) {
				return prevEvaluation.map((item, i) => (i === index ? updatedResponse : item))
			}
			return [...prevEvaluation, { criteriaId, response: dataset }]
		})
	}

	const handleSaveEvaluation = async () => {
		try {
			const payload = evaluation.map(({ criteriaId, response, id }) => ({
				id,
				criteriaId,
				response,
			}))

			await Promise.all(payload.map(item => Evaluation360.updateAnswers(item.id, { response: item.response })))

			setIsEditing(false)
		} catch (error) {
			console.error('Erro ao salvar as respostas:', error)
		}
	}

	const handleDelete = async () => {
		try {
			const responsesId = evaluation.map(item => item.id)
			const payload = {
				templateId: templateId,
				responsesId: responsesId,
			}

			await Evaluation360.deleteEvaluation(selectedRespondentId, payload)

			setTargets(prevTargets => prevTargets.filter(target => target.respondentId !== selectedRespondentId))
			setOpen(false)
		} catch (error) {
			console.error('Erro ao deletar a avaliação:', error)
		} finally {
			setOpen(false)
		}
	}

	const filteredTargets = targets?.filter(target => {
		return (
			target.name.toLowerCase().includes(searchName.toLowerCase()) &&
			(!selectedRelation || target.relation === selectedRelation) &&
			(!selectedStatus || target.status === selectedStatus)
		)
	})

	function handleSelect(e, type) {
		if (type === 'relation') setSelectedRelation(e.id)
		if (type === 'status') setSelectedStatus(e.id)
	}

	const clearFilters = () => {
		setSearchName('')
		setSelectedRelation(null)
		setSelectedStatus(null)
	}

	return (
		<div>
			<div className='tw-flex tw-items-center tw-justify-between tw-gap-4 tw-mr-4'>
				<div className='tw-flex tw-items-center tw-gap-4'>
					<h4 className='tw-m-0 tw-p-0 tw-font-bold'>{evaluation360.evaluationHistoric}</h4>
				</div>
			</div>

			<div className='tw-flex tw-items-center tw-gap-2 tw-pr-9'>
				<FormattedMessage id={'searchEmployee'}>
					{msg => (
						<input
							type='text'
							className='tw-h-[32px] tw-w-3/6 border'
							placeholder={msg}
							style={{ borderRadius: 6 }}
							value={searchName}
							onChange={e => setSearchName(e.target.value)}
						/>
					)}
				</FormattedMessage>
				<Select
					list={relationOptions}
					option={selectedRelation}
					onChange={e => handleSelect(e, 'relation')}
					placeholder={evaluation360.requiredField}
					className='tw-w-2/6'
				/>
				<Select list={statusOptions} option={selectedStatus} onChange={e => handleSelect(e, 'status')} placeholder='Status' className='tw-w-2/6' />
				<button className='tw-h-[38px] tw-bg-white tw-w-1/6 border tw-rounded-md' onClick={clearFilters}>
					{evaluation360.btnCleanFilters}
				</button>
			</div>
			<div className='tw-mr-4 tw-h-[600px] tw-overflow-y-scroll tw-pr-4'>
				<div className='border tw-rounded-md overflow-hidden'>
					<div className='tw-grid tw-grid-cols-4 tw-gap-4 tw-bg-[#F1F4F9] tw-py-2 tw-px-3 border-bottom'>
						<div className='tw-flex tw-items-center tw-font-bold tw-text-sm tw-gap-2 tw-col-span-2'>
							Colaborador
							<HiChevronUpDown color='#64748B' size={18} />
						</div>
						<div className='tw-flex tw-items-center tw-font-bold tw-text-sm tw-gap-2'>
							{evaluation360.jobRelationshop}
							<HiChevronUpDown color='#64748B' size={18} />
						</div>
						<div className='tw-flex tw-items-center tw-font-bold tw-text-sm tw-gap-2 tw-pl-4'>
							Status
							<HiChevronUpDown color='#64748B' size={18} />
						</div>
						<div className='tw-flex tw-items-center tw-font-bold tw-text-sm tw-gap-2'></div>
					</div>
					<ul className='tw-p-0 tw-m-0'>
						{filteredTargets?.map((target, index) => (
							<li key={target.respondentId} className={`border-bottom ${index === openIndex ? 'tw-bg-purple ' : 'tw-bg-white'}`}>
								<div
									onClick={() => handleAccordionClick(index, target.respondentId)}
									className={`tw-grid tw-grid-cols-4 tw-gap-4 tw-px-3 tw-py-4 tw-cursor-pointer ${index === openIndex ? 'tw-text-white' : ''} `}
								>
									<div className='tw-flex tw-gap-2 tw-items-center tw-col-span-2'>
										<div className='tw-w-[46px] tw-h-[46px] tw-rounded-full   tw-bg-gray-400'></div>
										<div className=''>
											<span className='tw-font-bold tw-text-base'>{target.name}</span>
											<p className={` tw-text-base tw-p-0 tw-m-0  ${index === openIndex ? '' : 'tw-text-gray-500'}`}>Project Manager</p>
										</div>
									</div>
									<div className='tw-flex tw-items-center tw-font-bold'>{translate[language][target.relation]}</div>
									<div className='tw-flex tw-items-center tw-justify-between  tw-pl-4'>
										<Pills finished={target.status !== 'active'} />
										<HiChevronDown />
									</div>
								</div>
								<div className={`tw-overflow-hidden tw-transition ${index === openIndex ? 'tw-max-h-full' : 'tw-max-h-0'}`}>
									<div className={`tw-p-4 ${isEditing ? `tw-bg-white` : `tw-bg-gray-50`} tw-w-[100%] `}>
										<div className='tw-grid tw-grid-cols-4 tw-p-3'>
											<div className='tw-font-bold'>{evaluation360.criterionTitle}</div>
											<div className='tw-col-span-2 tw-font-bold'>{evaluation360.descriptionTitle}</div>
											<div className='tw-font-bold'>Nota</div>
										</div>
										{loading ? (
											<div className='tw-flex tw-items-center tw-justify-center tw-w-full tw-h-[200px]'>
												<Loading />
											</div>
										) : evaluation.length > 0 ? (
											<>
												{evaluation.map(answer => (
													<div key={answer.id} className='tw-grid tw-grid-cols-4 tw-p-3 border-bottom tw-items-center'>
														<div>{answer.criteria?.name}</div>
														<div className='tw-col-span-2'>{answer.criteria?.description}</div>
														<div className='tw-flex tw-items-center'>
															<EvaluationsStars
																stars={answer.response}
																onClick={
																	isEditing
																		? data =>
																				handleEvaluation({
																					...data,
																					criteriaId: answer.criteriaId,
																				})
																		: null
																}
																criteriaId={answer.criteriaId}
															/>
														</div>
													</div>
												))}

												{target.status === 'active' && (
													<div className='tw-flex tw-gap-2 tw-items-center tw-justify-end tw-pt-3'>
														<button
															onClick={event => {
																event.stopPropagation()
																setSelectedRespondentId(target.respondentId)
																setOpen(true)
															}}
															className='border-0 tw-rounded-full tw-bg-gray-50 tw-text-error-500 tw-w-[150px] tw-py-2 tw-gap-2 tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-200 active:tw-text-white active:tw-bg-error-500'
														>
															<HiMiniTrash /> Eliminar
														</button>
														<button
															onClick={event => {
																event.stopPropagation()
																if (isEditing) {
																	handleSaveEvaluation()
																} else {
																	setIsEditing(true)
																}
															}}
															className='border-0 tw-rounded-full tw-bg-purple hover:tw-bg-purple-700 active:tw-bg-purple-700 tw-text-white tw-w-[150px] tw-py-2'
														>
															{isEditing ? 'Guardar' : 'Editar'}
														</button>
													</div>
												)}
											</>
										) : (
											<p className='tw-text-gray-500 tw-text-center tw-py-4'>{evaluation360.emptyEvaluation}</p>
										)}
									</div>
								</div>
							</li>
						))}
					</ul>
				</div>
			</div>
			<ModalAlert show={open} setShow={setOpen} onClick={handleDelete} />
		</div>
	)
}
